import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import type { ModalProps } from '@/types'
import type { GtmTriggerName } from '../../../../constants/gtm'
import { PlanUpdatedLayout } from './PlanUpdatedLayout'

type Props = ModalProps & {
  planId: string
  gtagId: GtmTriggerName
  onViewed: () => void
  title: string
  text: string
  buttonTitle: string
  onButtonClick: () => void
}

export const PlanUpdated: React.FC<Props> = ({
  closeButton,
  planId,
  gtagId,
  onViewed,
  title,
  text,
  buttonTitle,
  onButtonClick,
}) => (
  <PlanUpdatedLayout
    closeButton={closeButton}
    planId={planId}
    gtagId={gtagId}
    onViewed={onViewed}
    title={title}
    text={text}
  >
    <Button priority="secondary" label={buttonTitle} onClick={onButtonClick} />
  </PlanUpdatedLayout>
)
